import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { CLICKABLE_COLOR, TEXT_GREY } from '@CSSVars/colors'

export const _MoreBtn = styled.button.attrs({
  className: 'moreRecipientText',
})`
  ${({ addEnabled }) => (addEnabled ? `
    border: none;
    display: inline-block;
    color: ${TEXT_GREY};
    line-height: 17px;
  ` : `
    border: none;
    display: inline-block;
    color: ${CLICKABLE_COLOR};
    &:hover,
    &:focus {
      cursor: pointer;
    }
  `)}
`
